import axios from 'axios';
import store from "./store";

const token = localStorage.getItem("adminToken");
const currentLang = store.state.currentLang; // Access the 'currentLang' state directly

const Axios = axios.create({
  // baseURL: 'https://jebsenboard.onrender.com',
  // baseURL: 'http://localhost:8080',
  baseURL: 'https://jebsenboard.onrender.com',
  headers: {
    'Content-type': 'application/json',
    Authorization: `Bearer ${token}`,
    lang: currentLang, // Use the 'currentLang' directly
  },
});

export default Axios;